<template>
  <div class="index">
    <!-- 轮播图 -->
    <div class="bigBox"></div>
    <!-- 按钮 -->
    <div class="iconBox">
      <div v-for="(item,key) in iconArr" :key="key" class="iconHan" @click="jump(item.path,key)">
        <div class="iconCentent" :style="item.color">
          <van-icon :name="item.icon" color="#fff" size="1.5rem"/>
        </div>
        <div class="iconText">{{item.lable}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        iconArr: [
          {
            icon: 'gold-coin',
            lable: '卡充值',
            color: '  background-color:#409EFF;',
            path: '/topUpRecharge/topUpRecharge'
          },
          {
            //  icon 可以去vant哪里获取，或者直接放上图片的地址
            icon: 'coupon',
            // icon的标题
            lable: '卡绑定',
            // icon的背景颜色
            color: ' background-color:#E6A23C;',
            // icon跳转的页面
            path: '/topUpRecharge/binding'
          },
        ]
      }
    },
    created () {
      this.$nextTick(() => {
        // 禁用右键
        document.oncontextmenu = new Function('event.returnValue=false')
        // 禁用选择
        document.onselectstart = new Function('event.returnValue=false')
      })
    },
    mounted () {

    },
    methods: {
      jump (imgUrl, key) {
        //  if (key == 0) {
        this.$router.push({path: imgUrl})
        //  }else{
        //  console.log(111);
        //  Dialog.alert({
        //     title: '提示',
        //     message: '商户未开通该协议产品',
        // }).then(() => {
        //     // on close
        // })
        //  }
      },
    },
  }
</script>
<style lang="less" scoped>
  .index {
    // 轮播样式
    .bigBox {
      margin-top: 5pt;
      height: 145pt;
      width: 100%;
      background-image: url('/static/images/img_qkier.jpg');
      background-size: cover;
      background-position: center;
    }

    // icon样式
    .iconBox {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
      // justify-content: left;
      // margin-top: 1rem;
      // background-color: #fff;
      .iconHan {
        width: 49.5%;
        height: 4rem;
        padding-top: 1rem;
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;

        .iconCentent {
          width: 2.3rem;
          height: 2rem;
          text-align: center;
          margin: 0 auto;
          padding-top: 0.4rem;
          border-radius: 0.5rem;

          > div {
            font-size: 0.35rem;
          }

        }

        .iconText {
          text-align: center;
          padding-top: 0.3rem;
        }
      }

      .borederTop {
        border-top: 1px solid #000;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/washingMachine/washClothes.vue